import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Button,
  TextField,
  Typography,
  Container,
  Alert,
  Avatar,
  CircularProgress,
    InputAdornment

} from "@mui/material";
import { useNavigate,useLocation } from "react-router-dom";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { isValidPhoneNumber } from 'react-phone-number-input';

function Register() {
  const phoneRef = useRef(null);  
  const location = useLocation();
  const preFilledEmail = location.state?.email || '';
  const [password, setPassword] = useState("Testing123*");
  const [displayName, setDisplayName] = useState("");
  const [phone, setPhone] = useState("");
  const [profilePicture, setProfilePicture] = useState(null);
  const [previewImage, setPreviewImage] = useState("");
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [email, setEmail] = useState(preFilledEmail);


  const validateUKPhone = (phoneNumber) => {
  return /^(\d){10,11}$/.test(phoneNumber);
};


  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // Remove non-digits
    setPhone(value);
  };

  const formatPhoneDisplay = (num) => {
  if (!num) return '';
  if (num.length <= 2) return num;
  if (num.length <= 5) return `${num.slice(0, 2)} ${num.slice(2)}`;
  return `${num.slice(0, 2)} ${num.slice(2, 5)} ${num.slice(5, 11)}`;
};

  useEffect(() => {
    // Focus the input if it loses focus unexpectedly
    if (phoneRef.current && document.activeElement !== phoneRef.current) {
      phoneRef.current.focus();
    }
  }, [phone]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.type.match('image.*')) {
        setError('Please select an image file (JPEG, PNG)');
        return;
      }

      const reader = new FileReader();
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        
        img.onload = () => {
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          
          const MAX_WIDTH = 800;
          const MAX_HEIGHT = 800;
          let width = img.width;
          let height = img.height;

          if (width > height) {
            if (width > MAX_WIDTH) {
              height *= MAX_WIDTH / width;
              width = MAX_WIDTH;
            }
          } else {
            if (height > MAX_HEIGHT) {
              width *= MAX_HEIGHT / height;
              height = MAX_HEIGHT;
            }
          }

          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0, width, height);

          const compressedData = canvas.toDataURL('image/jpeg', 0.7);
          
          setPreviewImage(compressedData);
          setProfilePicture(compressedData);
          setError('');
        };
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async () => {
    if (!email || !password || !displayName || !phone) {
      setError('Please fill all required fields');
      return;
    }

    if (!validateUKPhone(phone)) {
    setError('Please enter a valid UK phone number (10-11 digits)');
    return;
  }

    setLoading(true);
    setError('');
    setMsg('');

    try {
      const res = await fetch("https://kast-server-713b1c89d478.herokuapp.com/api/auth/register", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ 
          email, 
          password, 
          displayName, 
          mobile: `+44${phone}`,
          profilePicture 
        }),
      });

      const data = await res.json();
      if (res.ok) {
        setMsg(data.message || "Registration successful! Check your email for verification (Please check your spam folder)");
         setTimeout(() => {
          navigate('/');
        }, 5000);
      } else {
        setError(data.error || "Registration failed");
      }
    } catch (err) {
      setError("Registration failed - server error");
      console.error("Registration error:", err);
    } finally {
      setLoading(false);
    }
    
  };

  return (
    <Container maxWidth="sm">
      <Box sx={{ mt: 10, p: 4 }}>
        <Typography variant="h5" gutterBottom sx={{ fontSize: "35px", color: "#74706B", textAlign: "center", fontWeight:600 }}>
          Your Kast Profile
        </Typography>

        {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}
        {msg && <Alert severity="success" sx={{ mb: 3 }}>{msg}</Alert>}

        <TextField
          fullWidth
          margin="normal"
          label="Email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          sx={{
            "& .MuiOutlinedInput-root": { borderRadius: "12px" },
            backgroundColor: 'white'
          }}
        />

        <TextField
          fullWidth
          margin="normal"
          label="Name"
          value={displayName}
          onChange={(e) => setDisplayName(e.target.value)}
          sx={{
            "& .MuiOutlinedInput-root": { borderRadius: "12px" },
            backgroundColor: 'white'
          }}
        />       

        <Box sx={{ mt: 2, mb: 1 }}>
        <TextField
          inputRef={phoneRef}
          fullWidth
          margin="normal"
          label="UK Phone Number"
          type="tel"
          value={formatPhoneDisplay(phone)}
          onChange={handlePhoneChange}
          placeholder="71 234 5678"
          inputProps={{
            inputMode: 'numeric',
            pattern: '[0-9 ]*',
            maxLength: 13 // Allows for spaces in display
          }}
          InputProps={{
            startAdornment: <InputAdornment position="start">+44</InputAdornment>,
          }}
          sx={{
            "& .MuiOutlinedInput-root": { 
              borderRadius: "12px",
              backgroundColor: 'white'
            }
          }}
        />
        <Typography variant="caption" sx={{ mt: 1, display: 'block' }}>
          Enter your UK phone number without the country code
        </Typography>
      </Box>

        <Box sx={{ mb: 3, mt: 3 }}>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Profile Picture (Optional)
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Avatar src={previewImage} sx={{ width: 64, height: 64 }} />
            <Button variant="outlined" component="label" disabled={loading}>
              Upload Image
              <input type="file" hidden accept="image/*" onChange={handleImageChange} />
            </Button>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <Button
            variant="contained"
            size="large"
            disabled={loading}
            sx={{ 
              py: 1.5,
              fontWeight: 600,
              backgroundColor: '#FF890A',
              '&:hover': { backgroundColor: '#e67a09' },
              borderRadius: '12px',
              width: '50%',
            }}
            onClick={handleSubmit}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : 'Continue'}
          </Button>
        </Box>

        <Button fullWidth sx={{ mt: 2 }} onClick={() => navigate("/")}>
          Already have an account? Login
        </Button>
      </Box>
    </Container>
  );
}

export default Register;